import { render, staticRenderFns } from "./AnalyticsForm.vue?vue&type=template&id=9b952f10&scoped=true&"
import script from "./AnalyticsForm.vue?vue&type=script&lang=js&"
export * from "./AnalyticsForm.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticsForm.vue?vue&type=style&index=0&id=9b952f10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b952f10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCol,VForm,VRow,VSubheader})
